import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';

interface IsUserLimitedInWorkspaceParams {
  host: string;
  userId: number;
  workspaceId: string;
}

export const isUserLimitedInWorkspace = async ({
  host,
  userId,
  workspaceId,
}: IsUserLimitedInWorkspaceParams): Promise<boolean> => {
  const response = await axiosClient.get<{ isDenied: boolean }>(
    `${assertServiceHost(host)}/v1/workspaces/${encodeURIComponent(workspaceId)}/permissions/${encodeURIComponent(
      userId
    )}/isDenied`,
    {
      userId,
    }
  );
  return response.data.isDenied;
};
